import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../../components/layout/Layout";

const oxygenTypes = [
  "regulator",
  "mask",
  "flow_meter",
  "stand",
  "pipe",
  "humidifier_bottle",
  "valve",
  "cover",
  "other",
];

const waterTypes = [
  "tap",
  "dispenser",
  "stand",
  "cover",
  "cap",
  "cleaning_brush",
  "other",
];

const materials = ["metal", "plastic", "rubber", "silicone", "glass", "other"];

export default function EditAccessory() {
  const [formData, setFormData] = useState({
    name: "",
    type: "",
    material: "",
    image: "",
    price: 0,
    stockQuantity: 0,
    discountPrice: 0,
  });
  const [previewImage, setPreviewImage] = useState(null);
  const [disableBtn, setDisableBtn] = useState(false);
  const location = useLocation();
  const data = location.state.data;
  const name = location.state.name;
  const navigate = useNavigate();
  const { id } = useParams();

  console.log("Data", location.state);

  useEffect(() => {
    // getCategoryById();
    setFormData({
      name: data.name,
      type: data.type || "",
      material: data.material,
      price: data.price,
      stockQuantity: data.stockQuantity,
      discountPrice: data.discountPrice,
    });
    setPreviewImage(`${process.env.REACT_APP_MEDIA_BASE_URL}/${data.imageUrl}`);
  }, []);

  const handleInputChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;

    // if (name === "image") {
    //   setFormData({ ...formData, image: e.target.files[0] });
    //   return;
    // }

    if (name === "image") {
      const file = e.target.files[0];
      setFormData({ ...formData, image: file });
      setPreviewImage(URL.createObjectURL(file)); // 👈 update preview
      return;
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisableBtn(true);
    try {
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
      };
      console.log(formData);
      const formdata = new FormData();
      formdata.append("name", formData.name);
      formdata.append("type", formData.type);
      formdata.append("material", formData.material);
      formdata.append("price", formData.price);
      formdata.append("stockQuantity", formData.stockQuantity);
      formdata.append("discountPrice", formData.discountPrice);
      formdata.append("accessoryId", id);
      if (formData.image) {
        formdata.append("image", formData.image);
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/accessory/edit-accessory`,
        formdata,
        { headers }
      );
      if (response.data.statusCode === 200) {
        navigate(-1);
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to edit Accessory. Please try again.", error);
    }
    setDisableBtn(false);
  };

  return (
    <>
      <Layout>
        <ToastContainer />
        <div>
          <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8 tracking-wide">
            {/* Header */}
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-medium">Edit Accessory</h2>

              <button
                onClick={() => navigate(-1)}
                className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
              >
                Back
              </button>

            </div>
            <div className="mt-10" onSubmit={handleSubmit}>
              <form action="">
                <div className="">
                  <label htmlFor="" className="text-sm">
                    Accessory Name
                  </label>{" "}
                  <br />
                  <input
                    type="text"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm "
                    placeholder="Write Accessory Name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mt-4">
                  <label htmlFor="" className="text-sm">
                    Accessory Material
                  </label>{" "}
                  <br />

                  <input
                    type="text"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm "
                    placeholder="Write Accessory Material"
                    name="material"
                    value={formData.material}
                    onChange={handleInputChange}
                    required
                  />

                  {/* <select
                    name="material"
                    id="material"
                    className="border border-black h-[40px] px-2.5 w-full mt-1 rounded-sm !outline-none text-sm"
                    value={formData.material}
                    onChange={handleInputChange}
                    required
                  >
                    <option name="" id="" value="">
                      Select Material
                    </option>
                    {materials.map((item) => {
                      return <option value={item}>{item}</option>;
                    })}
                  </select> */}
                </div>
                <div className="mt-4">
                  <label htmlFor="" className="text-sm">
                    Accessory Type
                  </label>{" "}
                  <br />

                    <input
                    type="text"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm "
                    placeholder="Write Accessory Type"
                    name="type"
                    value={formData.type}
                    onChange={handleInputChange}
                    required
                  />

                  {/* <select
                    name="type"
                    id="type"
                    className="border border-black h-[40px] px-2.5 w-full mt-1 rounded-sm !outline-none text-sm"
                    value={formData.type}
                    onChange={handleInputChange}
                    disabled={!["water", "oxygen"].includes(name)}
                    required
                  >
                    <option name="" id="" value="">
                      Select Type
                    </option>
                    {name === "water" &&
                      waterTypes.map((item) => {
                        return <option value={item}>{item}</option>;
                      })}
                    {name === "oxygen" &&
                      oxygenTypes.map((item) => {
                        return <option value={item}>{item}</option>;
                      })}
                  </select> */}
                </div>
                <div className="mt-4">
                  <label htmlFor="" className="text-sm">
                    Quantity
                  </label>{" "}
                  <br />
                  <input
                    type="number"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                    placeholder="Enter Product Quantity"
                    name="stockQuantity"
                    value={formData.stockQuantity}
                    onChange={handleInputChange}
                    min={0}
                    required
                  />
                </div>
                <div className="mt-4">
                  <label htmlFor="" className="text-sm">
                    Original Price
                  </label>{" "}
                  <br />
                  <input
                    type="number"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                    placeholder="Enter Accessory Price"
                    name="price"
                    value={formData.price}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mt-4">
                  <label htmlFor="" className="text-sm">
                    Discounted Price
                  </label>{" "}
                  <br />
                  <input
                    type="number"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                    placeholder="Enter Discounted Price"
                    name="discountPrice"
                    value={formData.discountPrice}
                    onChange={handleInputChange}
                    min={0}
                    required
                  />
                </div>
                {/* Accessory Image */}
                <div className="mt-4">
                  <label htmlFor="accessoryImage" className="text-sm">
                    Accessory Image
                  </label>{" "}
                  <br />
                  {previewImage && (
                    <img
                      src={previewImage}
                      alt="Preview"
                      className="h-[100px] w-[120px] rounded-lg object-cover mb-2"
                    />
                  )}
                  <br />
                  <input
                    type="file"
                    className="block w-full text-sm text-slate-800 file:mr-4 file:px-6 file:py-2 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-slate-100 file:text-[#ff4141] cursor-pointer mt-2"
                    placeholder="Choose Picture"
                    name="image"
                    onChange={handleInputChange}
                  // required
                  />
                  <br />
                </div>
                <div className="mt-8 text-end">
                  <button
                    type="submit"
                    className="bg-[#2c2c38] text-white h-[40px] px-8 rounded-md text-sm hover:bg-[#191919]"
                    disabled={disableBtn}
                  >
                    <i className="fa fa-plus"></i>{" "}
                    {disableBtn ? "Updating ..." : "Edit Accessory"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}
